import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FPSStats from 'react-fps-stats';
import 'react-dat-gui/build/react-dat-gui.css';
import DatGui, { DatColor, DatNumber, DatBoolean } from 'react-dat-gui';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var ParamsController =
/*#__PURE__*/
function (_Component) {
  _inherits(ParamsController, _Component);

  function ParamsController() {
    _classCallCheck(this, ParamsController);

    return _possibleConstructorReturn(this, _getPrototypeOf(ParamsController).apply(this, arguments));
  }

  _createClass(ParamsController, [{
    key: "render",
    value: function render() {
      var data = this.props.data;
      return React.createElement(DatGui, {
        data: data,
        onUpdate: this.props.onParamChanged
      }, React.createElement(DatColor, {
        path: "color",
        label: "Color"
      }), React.createElement(DatNumber, {
        path: "count",
        label: "Count",
        min: 0,
        max: 5000,
        step: 50
      }), React.createElement(DatNumber, {
        path: "blur",
        label: "Blur",
        min: 0,
        max: 3,
        step: 0.1
      }), React.createElement(DatNumber, {
        path: "size",
        label: "Size",
        min: 0.1,
        max: 10,
        step: 0.1
      }), React.createElement(DatNumber, {
        path: "speed",
        label: "Speed",
        min: 0,
        max: 6,
        step: 0.1
      }), React.createElement(DatNumber, {
        path: "fadeSpeedRate",
        label: "Fade speed rate",
        min: 0,
        max: 0.4,
        step: 0.01
      }), React.createElement(DatBoolean, {
        path: "randomFadeTime",
        label: "Random fade time"
      }), React.createElement(DatBoolean, {
        path: "differentSize",
        label: "Different size"
      }), React.createElement(DatBoolean, {
        path: "isGradient",
        label: "Gradient style"
      }));
    }
  }]);

  return ParamsController;
}(Component);

_defineProperty(ParamsController, "propTypes", {
  data: PropTypes.object,
  onParamChanged: PropTypes.func
});

var Firefly =
/*#__PURE__*/
function () {
  function Firefly(canvasParams, settings) {
    _classCallCheck(this, Firefly);

    this.seed = Math.random() + .4;
    this.context = canvasParams.canvasContext;
    this.width = canvasParams.width;
    this.height = canvasParams.height;
    this.x = Math.random() * this.width;
    this.y = Math.random() * this.height;
    this.speed = settings.speed;
    this.size = settings.differentSize ? settings.size * this.seed : settings.size;
    this.color = settings.color;
    this.rgbColor = this.hexToRGB(this.color);
    this.isGradient = settings.isGradient;
    this.fadeSpeedRate = settings.fadeSpeedRate;
    this.randomFadeTime = settings.randomFadeTime;
    this.fadeSpeed = 0;
    this.dx = Math.random() * 2 * (Math.random() < .5 ? -1 : 1);
    this.dy = Math.random() * 2 * (Math.random() < .5 ? -1 : 1);
  }

  _createClass(Firefly, [{
    key: "move",
    value: function move() {
      this.x += this.speed * Math.sin(this.dx);
      this.y += this.speed * Math.sin(this.dy);
      if (this.x > this.width || this.x < 0) this.dx *= -1;
      if (this.y > this.height || this.y < 0) this.dy *= -1;
    }
  }, {
    key: "buildGradientStyle",
    value: function buildGradientStyle(radius) {
      var style = this.context.createRadialGradient(this.x, this.y, 0, this.x, this.y, radius * radius);
      style.addColorStop(0.0, "rgba(".concat(this.rgbColor, ",1)"));
      style.addColorStop(0.1, "rgba(".concat(this.rgbColor, ",0.3)"));
      style.addColorStop(1.0, "rgba(".concat(this.rgbColor, ",0)"));
      return style;
    }
  }, {
    key: "show",
    value: function show() {
      var radius = this.size * Math.abs(Math.cos(this.fadeSpeed));
      this.context.beginPath();
      this.context.arc(this.x, this.y, radius, 0, 2 * Math.PI);
      this.context.closePath();
      this.fadeSpeed += this.fadeSpeedRate * (this.randomFadeTime ? this.seed : 1);
      this.context.fillStyle = this.isGradient ? this.buildGradientStyle(radius) : this.color;
      this.context.fill();
    }
  }, {
    key: "updateCanvasSize",
    value: function updateCanvasSize(width, height) {
      this.width = width;
      this.height = height;
      this.update();
    }
  }, {
    key: "updateSettings",
    value: function updateSettings(settings) {
      this.speed = settings.speed;
      this.size = settings.differentSize ? settings.size * this.seed : settings.size;
      this.color = settings.color;
      this.rgbColor = this.hexToRGB(this.color);
      this.isGradient = settings.isGradient;
      this.fadeSpeedRate = settings.fadeSpeedRate;
      if (!settings.randomFadeTime) this.fadeSpeed = 0;
      this.randomFadeTime = settings.randomFadeTime;
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      this.move();
      this.show();
    }
  }, {
    key: "hexToRGB",
    value: function hexToRGB(hex) {
      hex = parseInt(hex.replace('#', ''), 16);
      return [hex >> 16 & 255, hex >> 8 & 255, hex & 255].join(',');
    }
  }]);

  return Firefly;
}();

var DEFAULT_SETTINGS = {
  color: "#FF9B00",
  size: 4.7,
  speed: 0.1,
  blur: 0,
  count: 300,
  fadeSpeedRate: 0.01,
  differentSize: true,
  isGradient: true,
  randomFadeTime: true
};

var Fireflies =
/*#__PURE__*/
function (_Component) {
  _inherits(Fireflies, _Component);

  function Fireflies(props) {
    var _this;

    _classCallCheck(this, Fireflies);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Fireflies).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateFireflies", function () {
      var fireflies = _this.state.firefliesArray;
      fireflies.forEach(function (firefly) {
        firefly.update();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "draw", function () {
      var canvasContext = _this.state.canvasContext,
          width = _this.state.width,
          height = _this.state.height;
      canvasContext.clearRect(0, 0, width, height);

      _this.updateFireflies();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var width = window.innerWidth,
          height = window.innerHeight,
          fireflies = _this.state.firefliesArray;
      fireflies.forEach(function (firefly) {
        firefly.updateCanvasSize(width, height);
      });

      _this.setState({
        width: width,
        height: height
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addFireflies", function (arr, count) {
      var canvasParams = {
        canvasContext: _this.state.canvasContext,
        width: _this.state.width,
        height: _this.state.height
      },
          settings = _this.state.settings;

      for (var j = 0; j < count; j++) {
        arr.push(new Firefly(canvasParams, settings));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeFireflies", function (arr, count) {
      arr.splice(arr.length - count);
    });

    _defineProperty(_assertThisInitialized(_this), "paramChangedHandler", function (data) {
      var diff = _this.state.settings.count - data.count;
      var fireflies = _this.state.firefliesArray;
      if (diff < 0) _this.addFireflies(fireflies, Math.abs(diff));
      if (diff > 0) _this.removeFireflies(fireflies, diff);
      fireflies.forEach(function (element) {
        element.updateSettings(data);
      });

      _this.setState({
        firefliesArray: fireflies,
        settings: data
      });
    });

    _this.state = {
      canvas: null,
      canvasContext: null,
      firefliesArray: [],
      settings: _objectSpread({}, DEFAULT_SETTINGS, _this.props.settings),
      width: _this.props.width,
      height: _this.props.height
    };
    return _this;
  }

  _createClass(Fireflies, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var canvas = document.getElementById('fireflies-canvas'),
          context = canvas.getContext("2d"),
          width = this.state.width,
          height = this.state.height;
      context.fillStyle = "rgba(30,30,30,1)";
      context.fillRect(0, 0, width, height);
      this.setState({
        canvas: canvas,
        canvasContext: context
      });
      var canvasParams = {
        canvasContext: context,
        width: width,
        height: height
      },
          settings = this.state.settings,
          fireflies = this.state.firefliesArray;

      for (var j = 0; j < settings.count; j++) {
        fireflies.push(new Firefly(canvasParams, settings));
      }

      this.setState({
        firefliesArray: fireflies
      });
      this.timerId = setInterval(function () {
        return _this2.draw();
      }, this.props.updateInterval);
      window.addEventListener("resize", this.resizeWindow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.timerId);
    }
  }, {
    key: "render",
    value: function render() {
      var displayParamsChanger = this.props.displayParamsChanger,
          displayFpsStats = this.props.displayFpsStats;
      return React.createElement(React.Fragment, null, React.createElement("canvas", {
        id: "fireflies-canvas",
        width: this.state.width,
        height: this.state.height,
        style: {
          WebkitFilter: "blur(".concat(this.state.settings.blur, "px)")
        }
      }), displayParamsChanger && React.createElement(ParamsController, {
        data: this.state.settings,
        onParamChanged: this.paramChangedHandler
      }), displayFpsStats && React.createElement(FPSStats, null));
    }
  }]);

  return Fireflies;
}(Component);

_defineProperty(Fireflies, "propTypes", {
  width: PropTypes.number,
  height: PropTypes.number,
  updateInterval: PropTypes.number,
  settings: PropTypes.object,
  displayParamsChanger: PropTypes.bool,
  displayFpsStats: PropTypes.bool
});

_defineProperty(Fireflies, "defaultProps", _objectSpread({}, Component.defaultProps, {
  width: window.innerWidth,
  height: window.innerHeight,
  updateInterval: 15,
  displayParamsChanger: true,
  displayFpsStats: true
}));

export default Fireflies;